import { LicenseServiceInterface, License, SingleResponse, AvailableLicense } from '../types'
import licenses from './fakes/licenses'
import { createFakeSingleResponse } from './fakes/createFakeResponse'

export default class MockLicenseService implements LicenseServiceInterface {
	public async add(customerId: number, id: number, quantity: number): Promise<SingleResponse<License>> {
		const serial = Math.random()
			.toString(36)
			.substring(8)
			.toUpperCase()
		const license: License = {
			type: 'CRM',
			quantity,
			serial,
			consumed: 0,
			end_customer_id: customerId,
			partner_id: 'mondago',
			display_name: `CRM display`,
			is_nfr: false
		}
		licenses.push(license)
		return createFakeSingleResponse(license)
	}

	public async get(): Promise<SingleResponse<License[]>> {
		return createFakeSingleResponse(licenses)
	}

	public async update(_: number, serial: string, quantity: number): Promise<SingleResponse<License>> {
		const index = licenses.findIndex(license => license.serial === serial)
		licenses[index].quantity = quantity
		return createFakeSingleResponse(licenses[index])
	}

	public async getAvailable(): Promise<SingleResponse<AvailableLicense[]>> {
		return {
			data: [
				{ id: 1, license_type: 'crm', partner_id: 'mondago', display_name: 'CRM integration', is_nfr: false },
				{ id: 2, license_type: 'crm', partner_id: 'mondago', display_name: 'CRM integration (NFR)', is_nfr: true },
				{ id: 3, license_type: 'ops', partner_id: 'mondago', display_name: 'Operator', is_nfr: false }
			]
		}
	}
}
